import { pricingData } from "@/db/pricingData";
import Image from "next/image";
import Link from "next/link";
import { FaCheck } from "react-icons/fa";


const PricingArea = () => {
  return (
    <div className="pricing-area bg-white pt-120 pb-95">
      <div className="container">
        <div className="section-title">
          <div className="title">
            <h2 className="fs-3 mb-0 fw-semibold text-uppercase">
              Understanding Our Pricing
            </h2>
          </div>
        </div>
        {/** Pricing data array */}

        <div className="d-flex  row g-3">
          {pricingData.map((item, index) => (
            <div key={index} className="col-lg-4 col-md-6 col-sm-12">
              <div className="card shadow-lg rounded hover-card h-100">
                <Image
                  src={item.img}
                  className="card-img-top p-1 rounded-3"
                  alt={item.title}
                  width={150}
                  height={100}
                />
                <div className="card-body">
                  <p className="fs-5 fw-semibold text-dark">{item.title}</p>


                  <p className="card-text fs-6">
                    <span className="fs-6 fw-medium me-1">Price :</span>
                    {item.price} </p>



                  <div className="d-flex justify-content-between position-relative" >
                    <ul className="list-unstyled fs-6 mb-3 ">
                      {item.features.map((feature, fIdx) => (
                        <li key={fIdx} className="text-muted d-flex align-items-center me-1 mb-1">
                          <FaCheck className="mx-2 text-primary" />
                          {feature}
                        </li>
                      ))}
                    </ul>

                    <Link  href={{
          pathname: "/enquiryPage",
          query: { title: item.title }, // 👈 use key:value (not just post.id)
        }}
                     className="d-inline-block position-absolute bottom-0 end-0 mb-2">
                      <button type="button" className="btn btn-primary">
                        Enroll Now
                      </button>
                    </Link>
                  </div>



                </div>
              </div>
            </div>
          ))}
        </div>





      </div>
    </div>
  );
};

export default PricingArea;
